import React from "react";
export default function WarningIcon(props) {
  return (
    <svg
      className={props.className}    
      width="48px"
      height="49px"
      viewBox="0 0 48 49"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Hair-Try-on"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Final-Try-on-Copy-28"
          transform="translate(-702.000000, -375.000000)"
          stroke="#000000"
          strokeWidth="3"
        >
          <g id="Group-9" transform="translate(483.000000, 345.427056)">
            <g id="Group-10" transform="translate(44.000000, 32.000000)">
              <g id="Group-5" transform="translate(145.500000, 0.000000)">
                <g id="Group-13" transform="translate(31.000000, 0.000000)">
                  <path
                    d="M22.5,31.5 C22.0857864,31.5 21.75,31.8357864 21.75,32.25 C21.75,32.6642136 22.0857864,33 22.5,33 C22.9142136,33 23.25,32.6642136 23.25,32.25 C23.25,31.8357864 22.9142136,31.5 22.5,31.5 L22.5,31.5"
                    id="Path"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <line
                    x1="22.5"
                    y1="25.5"
                    x2="22.5"
                    y2="9"
                    id="Path"
                    strokeLinecap="round"
                  ></line>
                  <path
                    d="M0,22.5 C0,34.9264069 10.0735931,45 22.5,45 C34.9264069,45 45,34.9264069 45,22.5 C45,10.0735931 34.9264069,0 22.5,0 C10.0735931,0 0,10.0735931 0,22.5 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
